var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13224_3388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 6.9987C12.8334 3.77704 10.2217 1.16536 7.00008 1.16536C3.77842 1.16536 1.16675 3.77704 1.16675 6.9987C1.16675 10.2204 3.77842 12.832 7.00008 12.832C10.2217 12.832 12.8334 10.2204 12.8334 6.9987Z",
    stroke: "#337CC1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 7.43685C4.66675 7.43685 5.60008 7.96916 6.06675 8.74935C6.06675 8.74935 7.46675 5.68685 9.33341 4.66602",
    stroke: "#337CC1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13224_3388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmarkIcon.52ccdafa354da108dfb71e970c00c266.svg";
export { ForwardRef as ReactComponent };